/** @jsxImportSource @emotion/react */
import Helmet from '../../components/Helmet'
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

const Locations = () => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 60vh;
        padding: 32px;
      `}
    >
      <Helmet title='Locations' />
      <h3
        css={css`
          font-size: 24px;
          font-weight: 600;
          color: ${colors.NEUTRAL_0};
          margin-bottom: 16px;
          text-align: center;
        `}
      >
        Locations Is Coming Soon
      </h3>
      <p
        css={css`
          font-size: 16px;
          color: ${colors.NEUTRAL_100};
          margin-bottom: 32px;
          text-align: center;
          text-transform: capitalize;
        `}
      >
        We&apos;re working hard to bring you this feature. Check back soon!
      </p>
    </div>
  )
}

export default Locations
